export default "__VITE_ASSET__DDfS53g___"